// usePipelineHealth - liefert den vollen CI/CD-Einrichtungsstatus fuer einen
// Space. Wird von der "Bereitschaft"-Spalte in Scene0 (Space-Details) benutzt,
// damit die Karte nicht mehr nur "Bereit fuer Transport" behauptet, sondern
// zeigt, ob Repository, Workflow und Stufen wirklich einsatzbereit sind.
//
// Backend: GET /api/cicd/pipeline/overview?spaceId=... liefert
//   { configured, health: { tokenSet, repoPrivate, workflowActive, stagesReady }, ... }
// (der Endpoint verlangt Admin - fuer Nicht-Admins ist die Antwort ein 403,
// wir fallen in dem Fall still auf "unbekannt" zurueck und blockieren die
// Karte nicht.)
//
// Nur EIN Fetch pro Space (keine Polling-Schleife) - der Space wechselt selten
// und die Antwort enthaelt drei bis vier GitHub-Aufrufe im Backend.

import { useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

const LEER = {
  loading: false,
  configured: false,
  tokenSet: false,
  repoPrivate: null,
  workflowActive: null,
  stagesReady: false,
  ready: false,
  forbidden: false,
  error: null,
};

export function usePipelineHealth(spaceId) {
  const [state, setState] = useState({ ...LEER, loading: !!spaceId });

  useEffect(() => {
    if (!spaceId) { setState(LEER); return; }
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    api(`/api/cicd/pipeline/overview?spaceId=${encodeURIComponent(spaceId)}`)
      .then((r) => {
        if (!alive) return;
        const configured = r?.configured !== false;
        const h = r?.health || {};
        const tokenSet = !!h.tokenSet;
        const workflowActive = h.workflowActive === true;
        const stagesReady = h.stagesReady === true;
        // "Bereit fuer Transport" = ALLES steht. Nur configured+tokenSet reicht
        // nicht: ohne synchrone Stufen laeuft der Dispatch auf ein GitHub-
        // Environment, das gar nicht existiert.
        const ready = configured && tokenSet && workflowActive && stagesReady;
        setState({
          loading: false,
          configured,
          tokenSet,
          repoPrivate: h.repoPrivate,
          workflowActive,
          stagesReady,
          ready,
          forbidden: false,
          error: null,
        });
      })
      .catch((e) => {
        if (!alive) return;
        // 403 = Nicht-Admin. Kein Fehler-Zustand, sondern still auf "unbekannt".
        const forbidden = e?.status === 403;
        setState({ ...LEER, loading: false, forbidden, error: forbidden ? null : (e?.message || null) });
      });
    return () => { alive = false; };
  }, [spaceId]);

  return state;
}
